import React, { useEffect, useMemo, useState } from 'react'
import { debounce } from 'lodash'
import { Link } from "react-router-dom"

const AutomatelyListHeader = ({ activeTab, onTabChange, filterValues, setFilterValues }) => {
    const [searchTerm, setSearchTerm] = useState(filterValues?.searchTerm || '')
    const updateSearchFilter = useMemo(() => debounce((value) => {
        setFilterValues((currentFilters) => ({ ...currentFilters, searchTerm: value }))
    }, 400), [setFilterValues])

    useEffect(() => {
        return () => updateSearchFilter.cancel()
    }, [updateSearchFilter])

    const handleSearchChange = (event) => {
        const { value } = event.target
        setSearchTerm(value)
        updateSearchFilter(value)
    }

    const handleStatusChange = (isActive) => {
        setFilterValues((currentFilters) => {
            const nextFilters = { ...currentFilters }
            if (isActive === null) delete nextFilters.isActive
            else nextFilters.isActive = isActive
            return nextFilters
        })
    }

    const isAllStatusesSelected = filterValues.isActive === undefined || filterValues.isActive === null

    return (
        <header className="automately-list-header">
            <div className="automately-list-heading">
                <nav className="automately-workspace-tabs" aria-label="Automation workspace views">
                    <button
                        type="button"
                        className={activeTab === 'automations' ? 'active' : ''}
                        aria-current={activeTab === 'automations' ? 'page' : undefined}
                        onClick={() => onTabChange('automations')}
                    >
                        <i className="fa fa-code-fork" /> Automations
                    </button>
                    <button
                        type="button"
                        className={activeTab === 'execution-logs' ? 'active' : ''}
                        aria-current={activeTab === 'execution-logs' ? 'page' : undefined}
                        onClick={() => onTabChange('execution-logs')}
                    >
                        <i className="fa fa-history" /> Execution logs
                    </button>
                </nav>

                <Link to="/automations/new" className="automately-new-button">
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    New automation
                </Link>
            </div>

            {activeTab === 'automations' && <div className="automately-list-toolbar">
                <label className="automately-search">
                    <i className="fa fa-search" aria-hidden="true"></i>
                    <input
                        type="search"
                        name="searchTerm"
                        placeholder="Search automations"
                        aria-label="Search automations"
                        onChange={handleSearchChange}
                        value={searchTerm}
                    />
                </label>

                <div className="automately-status-filter" aria-label="Filter automations by status">
                    <button type="button" className={isAllStatusesSelected ? 'active' : ''} onClick={() => handleStatusChange(null)}>All</button>
                    <button type="button" className={filterValues.isActive === true ? 'active' : ''} onClick={() => handleStatusChange(true)}>
                        <span className="automately-filter-dot active"></span>Active
                    </button>
                    <button type="button" className={filterValues.isActive === false ? 'active' : ''} onClick={() => handleStatusChange(false)}>
                        <span className="automately-filter-dot inactive"></span>Inactive
                    </button>
                </div>
            </div>}
        </header>
    )
}

export default AutomatelyListHeader
